<template>
  <div class="order_manage_box">
    <div style="height: 90px;">
      <HomeHeader></HomeHeader>
    </div>
    <div class="order_box">
      <div></div>
      <div class="order_box_content">
        <div class="left_box">
          <el-menu :default-active="$route.fullPath" class="el-menu-vertical-demo" router>
            <!-- 订单管理 -->
            <el-submenu index="2">
              <template slot="title">
                <img src="../../../assets/newImage/jiudianjieshao.png" style="margin-left: 5px;">
                <span slot="title">{{ $t('header.order_center') }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/orderManage/OrderList">{{ $t('center.Hotel_order') }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- 工单管理 -->
            <el-menu-item index="/orderManage/WorkOrderManage">
              <img src="../../../assets/newImage/workOrder.png" style="margin-left: 6px;">
              <span style="font-weight: 600;">工单管理</span>
            </el-menu-item>
            <!-- 账单管理 -->
            <el-submenu index="3" v-if="partnerInfo.personType == 1 || $commonUtil.getAccountPermission('hotelBill')">
              <template slot="title">
                <img src="../../../assets/newImage/zhangdan.png" style="margin-left: 5px;">
                <span slot="title">账单管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/orderManage/hotelBill">酒店账单明细</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="4" v-if="partnerInfo.settleWay === 1">
              <template slot="title">
                <img src="../../../assets/newImage/invoice.png" style="margin-left: 5px;">
                <span slot="title">发票管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/orderManage/invoiceManage">发票管理</el-menu-item>
                <el-menu-item index="/orderManage/invoiceList">发票明细</el-menu-item>
                <el-menu-item index="/orderManage/userInvoiceManage">发票信息维护</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- 账号管理 -->
            <el-submenu index="1">
              <template slot="title">
                <img src="../../../assets/newImage/touxiang.png" style="margin-left: 5px;width: 16px;height: 16px;">
                <span slot="title">账号管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/orderManage/AccountInfo"
                              v-if="partnerInfo.personType == 1 || $commonUtil.getAccountPermission('accountInfo')">
                  {{ $t('center.Account_information') }}
                </el-menu-item>
                <el-menu-item index="/orderManage/BillDeatil">{{ $t('center.Hotel_bill_details') }}</el-menu-item>
                <el-menu-item index="/orderManage/AccountSetting">
                  {{ $t('center.Account_settings') }}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- 常用联系人 -->
            <el-menu-item index="/orderManage/Contacts">
              <img src="../../../assets/newImage/lxrimg.png" style="margin-left: 6px;">
              <span style="font-weight: 600;">{{ $t('center.contact_management') }}</span>
            </el-menu-item>
            <!-- 子账号管理 -->
            <el-menu-item index="/orderManage/SubAccount" v-if="partnerInfo.personType == 1">
              <img src="../../../assets/newImage/zhizhanghao.png" style="margin-left: 6px;">
              <span style="font-weight: 600;">{{ $t('center.Sub_account_management') }}</span>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="right_box" :style="'min-height:' + height + 'px;'">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
      <div></div>
    </div>
    <div style="background-color: #fff;margin-top: 40px;">
      <ContantUs />
      <footerInfo />
    </div>
  </div>
</template>

<script>
import HomeHeader from '../booking/components/HomeHeader.vue';
import ContantUs from '../booking/components/ContantUs.vue';
import footerInfo from '../frame/footerInfo.vue';
export default {
  data () {
    return {
      height: 0,
      partnerInfo: {}
    }
  },
  components: {
    HomeHeader,
    ContantUs,
    footerInfo
  },
  created () {
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    if (!this.partnerInfo) {
      this.$message.warning('请登录后再查看')
      this.$router.push('/login')
    }
  },
  mounted () {
    let info = document.documentElement.getBoundingClientRect()
    this.height = info.height - 90 - 40;
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.order_manage_box {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.order_box {
  display: grid;

  @media screen and (min-width: 992px) {
    grid-template-columns: 5% 1fr 5%;
  }

  @media screen and (max-width: 992px) {
    grid-template-columns: 5% 1fr 5%;
  }

  .order_box_content {
    display: grid;
    grid-template-columns: 225px 1fr;
    grid-column-gap: 20px;

    .left_box {
      min-width: 200px;
    }

    .right_box {
      overflow-y: scroll;
    }
  }

  /deep/.el-submenu .el-menu-item {
    min-width: 0;
    border-right: 2px solid #fff;
  }

  /deep/.el-menu-item.is-active {
    border-right: 2px solid #1e50f0;
    background-color: #eff3fe;
  }

  /deep/.el-submenu__title *,
  /deep/.el-menu-item * {
    font-size: 14px;
    font-weight: bold;
    font-family: '苹方';
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/orderManage.vue